import { Injectable, Type } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Logger, Dialog } from '../types/common';

/**
 *  è®¾è®¡å¨éç½®
 *
 * @export
 * @abstract
 */
@Injectable({ providedIn: 'root' })
export abstract class DynamicFormCommonConfig {
  /**
   * æ¥å¿
   *
   */
  abstract log: Logger;

  /**
   * å¼¹åºæ¡
   *
   */
  abstract dialog: Dialog;

  /**
   * æ´æ°æ é¢
   *
   */
  abstract updateTitle(activeRoute: ActivatedRoute, title: string): void;
}
